export const asHz = (n) => n;
export const asDb = (n) => n;
export const asDeg = (n) => n;
export const asOhm = (n) => n;
export const formatHz = (f) => {
    const n = f;
    if (n >= 1e9)
        return `${(n / 1e9).toFixed(4)} GHz`;
    if (n >= 1e6)
        return `${(n / 1e6).toFixed(4)} MHz`;
    if (n >= 1e3)
        return `${(n / 1e3).toFixed(4)} kHz`;
    return `${n} Hz`;
};
export const formatDb = (d) => `${d.toFixed(2)} dB`;
export const formatDeg = (a) => `${a.toFixed(1)}°`;
export const formatOhm = (z) => `${z.toFixed(1)} Ω`;
//# sourceMappingURL=units.js.map